import { Injectable } from '@angular/core';
import { LoginResponse } from '../models/auth.model';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  private readonly LOGIN_RESPONSE_KEY = 'loginResponse';
  private readonly TOKEN_KEY = 'kali_token';

  constructor() { }

  saveLoginResponse(response: LoginResponse): void {
    localStorage.setItem(this.LOGIN_RESPONSE_KEY, JSON.stringify(response));
    if (response.token) {
      localStorage.setItem(this.TOKEN_KEY, response.token);
    }
  }

  getLoginResponse(): LoginResponse | null {
    const response = localStorage.getItem(this.LOGIN_RESPONSE_KEY);
    if (response) {
      return JSON.parse(response);
    }
    return null;
  }

  getTenant(): string | null {
    return this.getLoginResponse()?.tenant ?? null;
  }

  getToken(): string | null {
    return localStorage.getItem(this.TOKEN_KEY);
  }

  clearSession(): void {
    localStorage.removeItem(this.LOGIN_RESPONSE_KEY);
    localStorage.removeItem(this.TOKEN_KEY);
    // Remove resquícios de sessões antigas gravadas no sessionStorage
    sessionStorage.removeItem(this.LOGIN_RESPONSE_KEY);
    sessionStorage.removeItem(this.TOKEN_KEY);
  }
}
